import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const dictionaries = {
  fetchAuthors: lazyModuleMethod(() => import('./fetchAuthors'), 'default'),
  fetchBiograhies: lazyModuleMethod(
    () => import('./fetchBiograhies'),
    'default'
  ),
  fetchBrands: lazyModuleMethod(() => import('./fetchBrands'), 'default'),
  fetchTags: lazyModuleMethod(() => import('./fetchTags'), 'default'),
}
